import React, { Fragment, useEffect, useState } from "react";
import { Card, Col, Row } from "reactstrap";
import { Button, Empty, Skeleton, Table } from "antd";
import { DataService } from "../../Services";
import _ from "lodash";
import { MainNavbar } from "../Core";
import { DownloadExcelFile } from "./UploadOutlet/TenantUtils";

const Ecommerce = () => {
	const [dataList, setDataList] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		setIsLoading(true);
		const getEcommerceData = async () => {
			let data = await DataService.fetchEcommerceDataFromS3();
			setDataList(data);
		};
		try {
			getEcommerceData();
		} catch (err) {
			console.err(err);
		} finally {
			setIsLoading(false);
		}
	}, []);
	let excelData = [];
	if (!_.isEmpty(dataList)) {
		excelData = dataList.map(item => {
			let single = {};
			for (let key in item) {
				if (key === "shop_name") {
					single["Shop Name"] = item[key];
				}
				if (key === "website") {
					single["Website"] = item[key];
				}
			}
			return single;
		});
	}

	const columns = [
		{
			title: "Shop Name",
			dataIndex: "shop_name",
			key: "shop_name"
		},
		// {
		// 	title: "ECommerce",
		// 	dataIndex: "ecommerce",
		// 	key: "ecommerce",
		// 	render: text => <Typography>{text.toUpperCase()}</Typography>
		// },
		{
			title: "Website",
			dataIndex: "website",
			key: "website",
			render: text => {
				const truncatedText = text && text.length > 50 ? text.substring(0, 50) + "..." : text;

				return (
					<a href={text} target="_blank" rel="noopener noreferrer">
						{truncatedText}
					</a>
				);
			}
		}
		// {
		// 	title: "Existing/Additional",
		// 	dataIndex: "existing_additional",
		// 	key: "existing_additional",
		// 	render: text => <Typography>{text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}</Typography>
		// }
	];
	return (
		<Fragment>
			<MainNavbar />
			<Row>
				<Col className="px-0">
					<div className="mt-2 w-100">
						<Card style={{ overflowX: "scroll", width: "auto" }}>
							<div style={{ display: "flex", justifyContent: "end" }}>
								<Button
									style={{ width: 150 }}
									disabled={_.isEmpty(dataList)}
									onClick={() => DownloadExcelFile(excelData, `Ecommerce-${Date.now()}`)}
								>
									Download
								</Button>
							</div>
							{dataList && !_.isEmpty(dataList) && !isLoading && (
								<Table
									dataSource={dataList || []}
									columns={columns}
									loading={!dataList}
									pagination={{
										position: ["bottomCenter"],
										pageSize: 100
									}}
								/>
							)}
							{_.isEmpty(dataList) && !isLoading && <Empty />}
							{isLoading && <Skeleton />}
						</Card>
					</div>
				</Col>
			</Row>
		</Fragment>
	);
};

export default Ecommerce;
